import * as React from 'react';
import { react, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import LaunchIcon from '@mui/icons-material/Launch';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Image from 'mui-image';
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from '../../services/TokenService';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Fab from '@mui/material/Fab';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import StyledRadio from '../StyledExtensions/StyledRadio'

import styles from './ActiveDonations.module.css'; // Import css modules stylesheet as styles






export default function ActiveDonations(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [donationsData, setDonationsData] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [filterNonProfit, setFilterNonProfit] = useState(true);
    const [filterForProfit, setFilterForProfit] = useState(true);
    const [filterFundraiser, setFilterFundraiser] = useState(true);
    const [filterIsLocal, setFilterIsLocal] = useState(false);

    const columns = [
        { id: 'name', label: 'Name', minWidth: (props.zipcode === undefined ? 170 : 140), visible:true },
        { id: 'code', label: 'City', minWidth: 100, visible: true },
        { id: 'pick', label: 'Pick', minWidth: 75, visible: (props.zipcode === undefined ? false : true)
        },
    ];

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        // Update the document title using the browser API
        if (props.isShown) {
            if (donationsData === null) {
                loadDonations();
            }
        }
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function zipCodeKeyPress(e) {
        if (e.keyCode == 13) {
            validateZip();
        }
    }


    if (props.isShown) {
        return buildDialog();
    } else {
        return null;
    }

    function loadDonations() {
        TokenService.post('', 'GetActiveDonationOrgs', '')
            .then((response) => {
                if (response !== null) {
                    response = response[Object.keys(response)[0]];
                    if (response.Result === "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        setDonationsData(jsonData);
                    }
                }
            })
            .catch((response) => {
                if (response !== null) {

                }
            });
    }

    function handleCompanyTypeFilterChange(filter, value) {
        if (filter === 'NonProfit') {
            setFilterNonProfit(value);
        }
        else if (filter === 'ForProfit') {
            setFilterForProfit(value);
        }
        else if (filter === 'Fundraiser') {
            setFilterFundraiser(value);
        }
        setPage(0);
    }

    function handleSearchValueChange(value) {
        setSearchValue(value);
        setPage(0);
    }

    function handleFilterLocalChanged(value) {
        setFilterIsLocal(value);
        setPage(0);
    }

    function isCompanyTypeSelected(donation) {
        return ((donation.CompanyType === 'NonProfit' && filterNonProfit === true) ||
            (donation.CompanyType === 'For Profit' && filterForProfit === true) ||
            (donation.CompanyType === 'Fundraiser' && filterFundraiser === true));
    }

    function isLocalOrState(donation) {
        if (filterIsLocal) {
            //props.localZipcode
            for (let j = 0; j < donation.Zipcodes.length; j++) {
                if (donation.Zipcodes[j] === props.localZipcode) {
                    return true;
                    break;
                }
            }
        }
        else {
            return true; // anything in the state
        }
    }

    function buildContent() {
        if (donationsData === null) {
            return (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="50px"
                >
                    <CircularProgress color="secondary" />
                </Box>
            );
        }
        else {
            let donationsList = [];
            let search = searchValue.trim().toLowerCase();
            for (let i = 0; i < donationsData.length; i++) {
                if (isCompanyTypeSelected(donationsData[i])) {
                    if (isLocalOrState(donationsData[i])) {
                        if (search.trim() === '') {
                            donationsList.push(donationsData[i]);
                        }
                        else {
                            if ((donationsData[i].DonationTitle.toLowerCase().indexOf(search) > -1) ||
                                (donationsData[i].CompanyState.toLowerCase().indexOf(search) > -1)) {
                                donationsList.push(donationsData[i]);
                            }
                            else if (!isNaN(search) && search.length == 5) {
                                // check the zipcodes
                                for (let j = 0; j < donationsData[i].Zipcodes.length; j++) {
                                    if (donationsData[i].Zipcodes[j] === search) {
                                        donationsList.push(donationsData[i]);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

            }
            return (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>

                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {props.localZipcode === undefined ? 
                                null
                                :
                                <div>
                                    <div style={{ display: 'flex' }}>
                                        <FormControlLabel control={<StyledRadio checked={filterIsLocal === false} onChange={(e) => handleFilterLocalChanged(false)} />} label={<span><img src='/images/Michigan.svg' style={{ height: '45px' }} /></span>} />
                                        <FormControlLabel control={<StyledRadio checked={filterIsLocal === true} onChange={(e) => handleFilterLocalChanged(true)} />} label={<span>Local</span>} />
                                    </div>
                                </div>
                            }
                    
                            <Paper elevation={6} id={styles.SelectionPaperItem} >
                                <div style={{ display: 'flex', backgroundColor: 'white', marginTop: '5px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '5px' }}>
                                        <div style={{ position: 'relative', alignSelf: 'center', cursor: 'pointer' }} onClick={() => handleCompanyTypeFilterChange('NonProfit', !filterNonProfit)}>
                                            <img src='/images/DonateIcon.png' style={{ width: '30px', opacity: filterNonProfit ? '1' : '.3' }} />
                                            {filterNonProfit == false ?
                                                <VisibilityOffIcon style={{ position: 'absolute', top: '15px', left: '25px' }} sx={{ color: 'var(--sipzee-gray)' }} />
                                                :
                                                <VisibilityIcon style={{ position: 'absolute', top: '15px', left: '25px' }} sx={{ color: 'var(--sipzee-gray)' }} />
                                            }

                                        </div>
                                        Charities
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '5px' }}>
                                        <div style={{ position: 'relative', alignSelf: 'center', cursor: 'pointer' }} onClick={() => handleCompanyTypeFilterChange('Fundraiser', !filterFundraiser)}>
                                            <img src='/images/FundraiserIcon.png' style={{ width: '30px', opacity: filterFundraiser ? '1' : '.3' }} />
                                            {filterFundraiser == false ?
                                                <VisibilityOffIcon style={{ position: 'absolute', top: '15px', left: '20px' }} sx={{ color: 'var(--sipzee-gray)' }} />
                                                :
                                                <VisibilityIcon style={{ position: 'absolute', top: '15px', left: '20px' }} sx={{ color: 'var(--sipzee-gray)' }} />
                                            }

                                        </div>
                                        Fundraisers
                                    </div>
                                    {/*<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '5px', marginRight: '8px' }}>*/}
                                    {/*    <div style={{ position: 'relative', alignSelf: 'center', cursor: 'pointer' }} onClick={() => handleCompanyTypeFilterChange('ForProfit', !filterForProfit)}>*/}
                                    {/*        <img src='/images/Business.png' style={{ width: '30px', opacity: filterForProfit ? '1' : '.3' }} />*/}
                                    {/*        {filterForProfit == false ?*/}
                                    {/*            <VisibilityOffIcon style={{ position: 'absolute', top: '15px', left: '25px' }} sx={{ color: 'var(--sipzee-gray)' }} />*/}
                                    {/*            :*/}
                                    {/*            <VisibilityIcon style={{ position: 'absolute', top: '15px', left: '25px' }} sx={{ color: 'var(--sipzee-gray)' }} />*/}
                                    {/*        }*/}

                                    {/*    </div>*/}
                                    {/*    Business*/}
                                    {/*</div>*/}
                                </div>
                            </Paper>
                           
                        </div>
                        <TextField label="Search"
                            onChange={(e) => handleSearchValueChange(e.target.value)}
                            value={searchValue}
                            variant="outlined"
                            style={{width:'100%',minWidth:'200px', maxWidth:'220px', marginTop: '5px', marginBottom:'2px', alignSelf:'flex-end', marginLeft:'auto' }}
                         />
                    </div>
                    <Paper sx={{ width: '100%', }}>

                        <TableContainer >
                            <Table aria-label="donations list" size="small">
                                <TableHead>
                                    <TableRow style={{backgroundColor:'var(--sipzee-green-3)'} }>
                                        <StyledTableCell />
                                        {columns.map((column) => (
                                            !column.visible ? null :
                                            <StyledTableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        donationsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                            return (
                                                <Row key={row.DonationId} row={row} index={index} canSelect={props.zipcode !== undefined} onSelected={props.onSelected } />
                                            );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={donationsList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            labelRowsPerPage=''
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        </Paper>
                    </div>
            );
        }
    }

    function buildDialog() {
        return <div>
            <Dialog
                open={true}
                onClose={props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{marginLeft:'10px'} }

            >
                <DialogTitle id="alert-dialog-title">
                    Organizations accepting bottle donations through Sipzee
                </DialogTitle>
                <DialogContent style={{ height: '90vh', paddingLeft:'5px' }}>
                    {buildContent() }
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }
}



function getTypeImage(companyType) {
    if (companyType == 'NonProfit') {
        return (
            <img src='./images/DonateIcon.png' style={{ height: '25px', width:'25px' } } />
        );
    }
    else if (companyType == 'For Profit') {
        return (
            <img src='./images/Business.png' style={{ height: '25px', width: '25px' }} />
        );
    }
    else if (companyType == 'Fundraiser') {
        return (
            <img src='./images/FundraiserIcon.png' style={{ height: '25px', width: '25px' }} />
        );
    }
    else {
        return null;
    }
}

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}
                style={{ backgroundColor: (props.index % 2 !== 0 ? 'white' : 'var(--sipzee-gray-3)') }}
            >
                <TableCell style={{ padding: '0px' }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" style={{ fontSize: '10pt' }}>
                    {row.DonationTitle.replace('&#39;', '\'')}
                </TableCell>
                <TableCell align="right" style={{ fontSize: '10pt' }}>{row.CompanyCity}</TableCell>
                {
                    !props.canSelect ? null :
                        <TableCell align="right" style={{ fontSize: '10pt' }}><Fab variant='outlined' size="small" sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={(e) => props.onSelected(row)}><CheckIcon /></Fab></TableCell>
                }
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit
                       >
                        <Box sx={{ margin: 1 }}>
                            <div style={{marginTop:'5px'} }>
                                {getTypeImage(row.CompanyType)} {row.CompanyType }
                            </div>
                            {row.Website.length > 0 ?
                                <div style={{ marginTop: '5px' }}><Button variant="outlined" color="primary" href={'https://' + row.Website.toLowerCase().replace('www.', '').replace('http://', '').replace('https://', '')} target='_blank' endIcon={<LaunchIcon />}>Website</Button></div>
                                : ''}

                            {row.CompanyDescription.length > 0 ?
                                <div style={{ marginTop: '5px' }}>Description: {row.CompanyDescription}</div>
                                : ''}
                           
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );

    
}